var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.952004 23.9998H23.0478C23.5731 23.9998 23.9998 23.5729 23.9998 23.0478V0.952004C23.9998 0.426643 23.5729 0 23.0478 0H0.952004C0.426643 0 9.20926e-08 0.426883 9.20926e-08 0.952004V23.0478C-0.000228909 23.5731 0.426655 24 0.952004 24V23.9998ZM22.0956 22.0628H16.4603V1.90407H22.0956V22.0628ZM1.90412 1.90407H14.5561V22.0628H1.90412V1.90407Z",
    fill: "#0D2549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.978 11.2282L7.07101 7.32119C6.87405 7.12423 6.64412 7.02576 6.38142 7.02576C6.11872 7.02576 5.88904 7.12423 5.69184 7.32119C5.29793 7.7151 5.29793 8.3062 5.69184 8.70012L8.90929 11.9176L5.52785 15.2995C5.13394 15.6934 5.13394 16.2845 5.52785 16.6784C5.92177 17.0723 6.51287 17.0723 6.90679 16.6784L11.0108 12.5744C11.2077 12.3775 11.3062 12.1476 11.3062 11.8849C11.3064 11.6222 11.175 11.3925 10.978 11.2283L10.978 11.2282Z",
    fill: "#0D2549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.30dd65b0007409d5ef24129ebd109b17.svg";
export { ForwardRef as ReactComponent };